import $ from "jquery";
import utils from './lsag.utils';

const refinements = {
    bindEvents() {
        $('#js-facet-size').on('change', '.js-multifacet-item', this.storeSizeSelection);
        $('#grid-page')
            .on('change', '.js-facet-checkbox', this.submitForm)
            .on('click', '.js-more-facet-values', this.showMoreFacets)
            .on('click', '.js-less-facet-values', this.hideMoreFacets)
            .on('click', '.js-open-facet', this.openFacet)
            .on('click', '.js-close-facet', this.closeFacet)
            .on('click', '.js-mobile-open-facets', this.mobileOpenFacets)
            .on('click', '.js-mobile-close-facets', this.mobileCloseFacets)
    },
    submitForm() {
        utils.showOverlay();
        $(this).closest('form').submit();
    },
    storeSizeSelection() {
        let selectedSizes = $('#js-facet-size .js-facet-checkbox:checked');
        if (selectedSizes.length === 1) {
            let checked = selectedSizes[0].form.innerText.trim();
            let size = checked.substring(0, checked.indexOf(' '));
            localStorage.setItem('selectedProductSize', size);
        } else {
            localStorage.removeItem('selectedProductSize');
        }
    },
    showMoreFacets() {
        $('.js-facet__array').addClass('c-facet__array--open');
        $('.js-more-facet-values').hide();
        $('.js-less-facet-values').show();
    },
    hideMoreFacets() {
        $('.js-facet__array').removeClass('c-facet__array--open');
        $('.js-less-facet-values').hide();
        $('.js-more-facet-values').show();
    },
    openFacet() {
        let target = $(this).data('id');
        $('#js-facet-' + target).addClass('c-facet__body--visible');
        $('.js-facet__array').hide();
        $('.js-facet__appearance').hide();
        // sessionStorage supported
        if (window.sessionStorage) {
            sessionStorage.setItem('openFacet', target);
        }

    },
    closeFacet() {
        $(this).closest('.c-facet__body').removeClass('c-facet__body--visible');
        $('.js-facet__array').show();
        $('.js-facet__appearance').show();
        // sessionStorage supported
        if (window.sessionStorage) {
            sessionStorage.removeItem('openFacet');
        }
    },
    mobileOpenFacets() {
        $('.js-facet__array').show();
    },
    mobileCloseFacets() {
        $('.js-facet__array').css({'display': ''});
    }
};

// DOM ready
$(() => {
    if ($('#grid-page')) {
        refinements.bindEvents();
        $('#js-facet-overlay').remove();
    }
});

export default refinements;
